import React, { Component } from 'react'
import { Carousel } from 'react-responsive-carousel';
// import 'react-responsive-carousel/lib/styles/carousel.min.css'

export default class DefaultCarousel extends Component {
  
  renderText(image) {
    if (image.text !== undefined) {
      return (
        <div className="carousel-content">
          <div className="carousel-left">
            <div className="carousel-text">{image.text}</div>
            <a href={image.link}>
              <div className="default-button default-button-white">
                Learn More
              </div>
            </a>
          </div>
        </div>
      );
    }
    return <></>;
  }
  
  render() {
    const {images} = this.props;
    return (
      <div className="default-carousel">
        <Carousel
        showThumbs={false}
        infiniteLoop={true}
        autoPlay={true}
        interval={5000}
        >
          {
            images.map(image => 
              <>
                <img src={image.img} className="intern-carousel-image"/>
                <div className="image-fade-left" />
                {this.renderText(image)}
              </>
            )
          }
        </Carousel>
      </div>
    )
  }
}
